import { render } from "./EditOrganization.vue?vue&type=template&id=2f6f1084&scoped=true"
import script from "./EditOrganization.vue?vue&type=script&lang=js"
export * from "./EditOrganization.vue?vue&type=script&lang=js"

import "./EditOrganization.vue?vue&type=style&index=0&id=2f6f1084&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6f1084"]])

export default __exports__